import FormLabelFes from './FormLabelFes'

export default {
  data: () => ({
    modelValue: ''
  }),
  inject: ['$validator'],
  components: {
    FormLabelFes
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    layout: {
      type: String,
      default: 'column'
    },
    inputWidth: { type: String },
    validation: {
      type: [String, Object],
      default: () => ({
        rules: {}
      })
    },
    autosave: { type: Boolean, default: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    showStrength: { type: Boolean, default: false },
    rows: [String, Number],
    cols: [String, Number],
    maxlength: [String, Number],
    minlength: [String, Number]
  },
  mounted() {
    this.onMounted()
  },
  watch: {
    value() {
      this.modelValue = this.value
    }
  },
  methods: {
    onMounted() {
      if (this.inputWidth && this.$refs.input) {
        this.$refs.input.style.width = this.inputWidth
      }
    },
    update($event) {
      if ($event) {
        this.$emit('input', $event.target.value)
        this.$emit('change', $event.target.value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/uFes/components/mixin.js